import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sweetgreen/garnish';

import { useIsLoggedIn } from '@order/AuthMachine';
import {
  AccountPaymentGiftCardLoading,
  AccountScreenContainer,
  AccountScreenTitle,
  GiftCardAccountSection,
  NotFoundView,
  PaymentAccountSection,
  SignedOutView,
} from '@order/components';
import { usePaymentMethods } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useLocalizationContext } from '@order/Localization';

// ─────────────────────────────────────────────────────────────────────────────

export const PaymentAndGiftCardsScreen = () => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();
  const { paymentMethods, isLoadingPaymentMethods } = usePaymentMethods();

  const isLoggedIn = useIsLoggedIn();
  const shouldSeparatePromoAndGiftCard = useFeatureFlag(
    'CELS-1410-separate-promo-and-gift-card',
  );

  // ─────────────────────────────────────────────────────────────────────

  if (!shouldSeparatePromoAndGiftCard) return <NotFoundView withoutFooter />;

  if (!isLoggedIn)
    return <SignedOutView redirectTo="payment-and-gift-cards" withoutFooter />;

  if (isLoadingPaymentMethods) return <AccountPaymentGiftCardLoading />;

  return (
    <AccountScreenContainer screen="payment-and-gift-cards">
      <AccountScreenTitle
        visibility="COMPACT"
        title={t('account.payment-and-gift-cards.title')}
      />

      <View style={match([styles.paymentSectionContainerXS, undefined])}>
        <PaymentAccountSection paymentMethods={paymentMethods} />
      </View>

      <GiftCardAccountSection />
    </AccountScreenContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  paymentSectionContainerXS: {
    marginBottom: theme.spacing['10'],
  },
});
